var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudiovideobg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 419,
    viewBox: "0 0 501 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.229 -14.5343C215.331 -8.3776 205.512 67.9962 163.313 103.616C112.46 146.54 20.3909 146.05 3.69983 210.44C-13.7203 277.641 33.0156 350.252 88.5735 391.938C139.169 429.9 207.629 419.614 270.229 410.418C321.634 402.867 366.064 379.422 405.315 345.409C448.65 307.856 501.241 267.753 500.999 210.44C500.758 153.217 445.174 116.566 404.182 76.6031C363.987 37.4184 326.036 -20.7929 270.229 -14.5343Z",
    fill: "#FDF8F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiovideobg);
export default __webpack_public_path__ + "static/media/audiovideobg.1f284125044c127f15bcc7d127370c99.svg";
export { ForwardRef as ReactComponent };